const hasWindow = typeof window !== 'undefined';

const getDevBackendOrigin = () => {
  if (!hasWindow) return '';

  const { hostname, port, protocol } = window.location;
  if (port !== '3000') return '';

  return normalizeUrl(`${protocol}//${hostname}:3001`);
};

export const normalizeUrl = (value) => {
  if (!value) return '';
  return String(value).trim().replace(/\/+$/, '');
};

export const stripApiSuffix = (value) => normalizeUrl(value).replace(/\/api$/, '');

export const getApiBaseUrl = () => {
  const configuredValue = normalizeUrl(process.env.REACT_APP_API_URL);

  if (configuredValue) {
    if (hasWindow) {
      try {
        return normalizeUrl(new URL(configuredValue, window.location.origin).toString());
      } catch (_) {
        return configuredValue;
      }
    }

    return configuredValue;
  }

  if (hasWindow) {
    const devBackendOrigin = getDevBackendOrigin();
    if (devBackendOrigin) {
      return `${devBackendOrigin}/api`;
    }

    return normalizeUrl(`${window.location.origin}/api`);
  }

  return '/api';
};

export const getSocketBaseUrl = () => stripApiSuffix(getApiBaseUrl());

export const getMediaBaseUrl = () => stripApiSuffix(getApiBaseUrl());